import {Component, Input, OnInit} from '@angular/core';
import {
    TranslationLocalization,
    TranslationModel,
    TranslationService
} from '../../services/wrapper/translation.service';
import {CoreDataService} from "../../services/wrapper/core-data.service";

@Component({
    selector: 'app-translation-element',
    templateUrl: './translation-element.component.html',
    styleUrls: ['./translation-element.component.scss']
})
export class TranslationElementComponent implements OnInit {
    @Input() public translation: any;
    @Input() public translationService: TranslationService;
    @Input() public parent: any;
    public languages: any;
    public isClose = true;
    showSubTrans: boolean = false;

    constructor(public coreDataService: CoreDataService) {
        this.languages = coreDataService.getLanguages();
    }

    ngOnInit() {
        if (this.translation.localizations != undefined && Object.keys(this.translation.localizations).length > 0) {
            this.languages.forEach(lang => {
                if (!Object.keys(this.translation.localizations).includes(lang.code)) {
                    this.translation.localizations[lang.code] = {value: ""};
                }
            });
        }
    }

    addSubToModel() {
        //TODO ide jön majd a mentés külön és a hozzá csatolás logika
        this.translation.subTranslations.unshift(new TranslationModel(this.translationService.environment));
        this.showSubTrans = true;
    }

    addLocalizations(translationKey) {
        //TODO ide jön majd a mentés külön és a hozzá csatolás logika
        const localizationMap = {};
        this.languages.forEach(lang => {
            localizationMap[lang.code] = new TranslationLocalization(translationKey);
        });
        this.translation.localizations = localizationMap
    }

    hideSubmodel(translation) {
        return (translation.localizations && Object.keys(translation.localizations).length > 0);
    }

    hideLocalizations(translation) {
        return translation.subTranslations.length > 0 || (translation.localizations && Object.keys(translation.localizations).length > 0);
    }

    changeLocalizationData(translation) {
        this.translationService.addToUpdate(translation);
    }

    copy(translation) {
        const copy = new TranslationModel(this.translationService.environment, translation);
        copy.translationKey += "_COPY";
        if (this.parent == null) {
            this.translationService.translations.unshift(copy)
        } else {

            this.parent.subTranslations.unshift(copy);
        }

    }
}
